// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"528":"reports","594":"about"}[chunkId] || chunkId) + "." + {"180":"5a11312c","215":"9c4bfd38","412":"e108e49f","499":"d7713fb5","528":"ccb32c13","594":"c6008850","645":"fa0b94c9","713":"62e9aae4","741":"be28f3dd"}[chunkId] + ".js";
};